export default "__VITE_ASSET__CNl5391w__"